// extracted by mini-css-extract-plugin
export default {"superCounter":"SuperCounter_superCounter__yvrCs"};